//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
export default {
  props: {
    article: {},
  },
  data() {
    return {
      AccountTypes: [],
      VatTypes: [],
      FilterAccountTypes: [],
      FilterVatTypes: [],
      dense: true,
    };
  },

  computed: {
    ...mapState("main", ["accounts", "vatTypes"]),
  },

  mounted: function() {
    this.initSelectBox();
  },

  methods: {
    ...mapActions("main", ["getVatType", "getAccount"]),

    async initSelectBox() {
      this.AccountTypes = this.accounts;
      if (!this.AccountTypes) {
        this.AccountTypes = await this.getAccount();
      }
      this.FilterAccountTypes = this.AccountTypes;

      this.VatTypes = this.vatTypes;
      if (!this.VatTypes) {
        this.VatTypes = await this.getVatType();
      }
      this.FilterVatTypes = this.VatTypes;
    },

    getAccountTypesFilter(val, update) {
      console.log("getAccountsFilter", this.AccountTypes);
      if (!this.AccountTypes) {
        update();
        return;
      }
      update(() => {
        this.AccountTypes = this.FilterAccountTypes.filter(
          (v) =>
            v.accountName.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            v.accountNumber > 3000 &&
            v.accountID == null
        );

        console.log("getAccountsFilter update ", this.AccountTypes);
      });
    },

    getVatTypesFilter(val, update) {
      console.log("getVatTypesFilter", this.VatTypes);
      if (!this.VatTypes) {
        update();
        return;
      }
      update(() => {
        this.VatTypes = this.FilterVatTypes.filter(
          (v) =>
            v.name.toLowerCase().indexOf(val.toLowerCase()) > -1 &&
            v.visible &&
            !v.deleted &&
            (v.vatCodeGroupID == 9 || v.vatCodeGroupID == 8)
        );

        console.log("getVatTypesFilter update", this.VatTypes);
      });
    },
  },
};
